import apiClient from 'src/utils/apiClient';

// **** Types **** //

/** Feature flags as returned by the API, keyed by their snake_case name. */
export type FeatureFlagsPayload = Record<string, boolean>;

// **** Constants **** //

// Used when the API is unreachable. Flags omitted here fall back to disabled.
const FALLBACK_FEATURE_FLAGS: FeatureFlagsPayload = {
  placement_transfer: true,
  decision_portal: true,
  atoz_notifications: true,
  job_modifications: true,
  correspondence: true,
};

// **** Functions **** //

/**
 * Fetch an object with the list of feature flags. If there's an issue with the API, fall
 * back to the hardcoded values.
 */
async function getFeatureFlags(): Promise<FeatureFlagsPayload> {
  try {
    const { data } = await apiClient.get<FeatureFlagsPayload>('/featureFlags');
    return data;
  } catch {
    return FALLBACK_FEATURE_FLAGS;
  }
}

/**
 * Update a particular feature flag.
 */
async function updateFeatureFlag(featureName: string, isEnabled: boolean): Promise<FeatureFlagsPayload> {
  const { data } = await apiClient.put<FeatureFlagsPayload>(`/featureFlags/${featureName}?enabled=${isEnabled}`);
  return data;
}

// **** Export default **** //

export default {
  getFeatureFlags,
  updateFeatureFlag,
} as const;
